import addDays from 'date-fns/addDays';
import endOfWeek from 'date-fns/endOfWeek';
import startOfWeek from 'date-fns/startOfWeek';
import subDays from 'date-fns/subDays';
import dayjs from 'dayjs';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import 'rsuite/dist/rsuite.css';
import {resetResponse, setAppointmentDate, setDoctorsDetailsList, sidebar} from '../../Redux/Slice/rootSlice';
import {getDashboardData, getDoctorsList} from '../../Redux/Thunk/Actions';
import '../../styles/Home.scss';

export default function Home(props) {
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const [dcount, setdcount] = useState(0);
  const [pcount, setpcount] = useState(0);
  const [acount, setacount] = useState(0);
  const [doctorcount, setdoctorcount] = useState(0);
  const [patientcount, setpatientcount] = useState(0);
  const [appoinmentcount, setappoinmentcount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([gt, it]);
  useEffect(() => {
    const dataPayload = {
      date_gt: range[0],
      date_lt: range[1]
    };

    const showDashboardError = () => {
      props.popupalert('true');
      props.popuptext('Dashboard data could not be loaded');
      setTimeout(() => {
        props.popupalert('false');
      }, 2000);
    };

    const fetchData = async () => {
      props.loaderchange('true');
      try {
        dispatch(setAppointmentDate(dayjs().format('YYYY-MM-DD')));

        const doctorsList = await dispatch(getDoctorsList());
        if (doctorsList?.payload?.data) {
          dispatch(setDoctorsDetailsList(doctorsList.payload.data));
        }

        const response = await dispatch(getDashboardData(dataPayload));
        if (response?.payload?.status?.code === 200) {
          const dashboardData = response.payload.data || {};
          const doctorTotal = dashboardData.doctor_count || 0;
          const patientTotal = dashboardData.patient_count || 0;
          const appointmentTotal = dashboardData.appointment_count || 0;

          setdcount(doctorTotal);
          setpcount(patientTotal);
          setacount(appointmentTotal);

          const intervalId1 = setInterval(() => {
            if (doctorTotal !== 0) {
              setdoctorcount(prevCount => {
                if (prevCount < doctorTotal) {
                  return prevCount + 1;
                } else {
                  clearInterval(intervalId1);
                  return prevCount;
                }
              });
            }
          });

          const intervalId3 = setInterval(() => {
            if (appointmentTotal !== 0) {
              setappoinmentcount(prevCount => {
                if (prevCount < appointmentTotal) {
                  return prevCount + 1;
                } else {
                  clearInterval(intervalId3);
                  return prevCount;
                }
              });
            }
          });

          const intervalId2 = setInterval(() => {
            if (patientTotal !== 0) {
              setpatientcount(prevCount => {
                if (prevCount < patientTotal) {
                  return prevCount + 1;
                } else {
                  clearInterval(intervalId2);
                  return prevCount;
                }
              });
            }
          });

          dispatch(resetResponse(''));
        } else {
          showDashboardError();
        }
      } catch (error) {
        showDashboardError();
      } finally {
        props.loaderchange('false');
      }
    };

    fetchData();
  }, [range]);
  function convert(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  }
  // console.log(acount,"acount");

  const handlechangedate = (name, value) => {
    if (value != null) {
      setrange(oldArray => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {};
  const predefinedBottomRanges = [
    {
      label: 'Today',
      value: [new Date(), new Date()],
      placement: 'left'
    },
    {
      label: 'Yesterday',
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: 'left'
    },
    {
      label: 'This week',
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: 'left'
    },
    {
      label: 'Last 30 days',
      value: [subDays(new Date(), 29), new Date()],
      placement: 'left'
    },

    {
      label: 'Last week',
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [addDays(startOfWeek(start, {weekStartsOn: 0}), -7), addDays(endOfWeek(start, {weekStartsOn: 0}), -7)];
      },
      appearance: 'default'
    },
    {
      label: 'Next week',
      closeOverlay: false,
      value: (value, index) => {
        console.log(value);
        const [start = new Date()] = value[index] || [];
        return [addDays(startOfWeek(start, {weekStartsOn: 0}), 7), addDays(endOfWeek(start, {weekStartsOn: 0}), 7)];
      },
      appearance: 'default'
    }
  ];

  return (
    <>
      <div className={sideactive ? 'dashboard-main-sa' : 'dashboard-main'}>
        <div class='page-header'>
          <div class='row'>
            <div class='col-sm-12'>
              <h3 class='page-title'>{'Welcome ' + localStorage.getItem('role') + '!'}</h3>
              <ul class='breadcrumb' style={{justifyContent: 'space-between'}}>
                <li class='breadcrumb-item active'>Dashboard</li>
                <li>
                  {' '}
                  {/* <div className="datepicker_dash">
                    <DateRangePicker
                      defaultValue={[
                        new Date(new Date().setDate(today.getDate() - 30)),
                        new Date(),
                      ]}
                      disabledDate={(date) => isAfter(date, new Date())}
                      editable={false}
                      appearance="default"
                      placement="bottomEnd"
                      size="lg"
                      ranges={predefinedBottomRanges}
                      placeholder="From - To"
                      style={{ width: 270, padding: 10 }}
                      onClean={(e) => cleaningrange(e)}
                      onChange={(e) => {
                        if (e != null) {
                          setrange([]);
                          setdoctorcount(0);
                          setpatientcount(0);
                          setappoinmentcount(0);
                          e.forEach((newValue) => {
                            var tzoffset =
                              new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                            var localISOTime = new Date(newValue - tzoffset)
                              .toISOString()
                              .slice(0, -1);
                            handlechangedate("validtill", localISOTime);
                          });
                        }
                      }}
                    />
                  </div> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='row'>
          {/* <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-primary border-primary">
                    <i class="bi bi-person-fill-add"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{doctorcount}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Doctors</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${doctorcount / 10}%` }}
                      aria-valuenow={doctorcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className='col-xl-4 col-sm-6 col-12 '>
            <div class='card'>
              <div
                class='card-body'
                style={{padding: '1.5rem', cursor: 'pointer'}}
                onClick={() => {
                  dispatch(sidebar('Patient Details'));
                  navigate('/Patients');
                }}>
                <div class='dash-widget-header'>
                  <span class='dash-widget-icon text-success'>
                    <i class='bi bi-person-bounding-box'></i>
                  </span>
                  <div class='dash-count'>
                    <h3>{patientcount}</h3>
                    {/* <h3>{pcount}</h3> */}
                  </div>
                </div>
                <div class='dash-widget-info'>
                  <h6 class='text-muted'>Patients</h6>
                  <div class='progress progress-sm'>
                    <div class='progress-bar bg-success' style={{width: `${patientcount / 10}%`}} aria-valuenow={patientcount} aria-valuemin='0' aria-valuemax='100%'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-person-vcard-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{appoinmentcount}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Appointment</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${appoinmentcount / 10}%` }}
                      aria-valuenow={appoinmentcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="col-xl-3 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-warning border-warning">
                    <i class="bi bi-currency-rupee"></i>
                  </span>
                  <div class="dash-count">
                    <h3>$62523</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Revenue</h6>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-warning w-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

